export const formTypes = [
  { value: "Basic Information Form", label: "Basic Info Form" },
  { value: "Service Form", label: "Service Form" },
  { value: "NOC", label: "NOC" },
  { value: "Documents", label: "Documents" },
  { value: "Plot Details Form", label: "Plot Details Form" },
] as const;
